import { CallbackObject } from 'api/core/get-page-function';
import { GetProductsVm } from './get-products.vm';
import { plainToClass } from 'class-transformer';
import { AxiosResponse } from 'axios';
import { instance } from 'api/core';

export const getProducts = async (offset: string, term: string | null, callback: CallbackObject<GetProductsVm>) => {
  const config: Record<string, any> = {
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      limit: 50,
      offset: offset,
    },
  };

  if (term) {
    config.params.term = term;
  }

  try {
    const res: AxiosResponse = await instance.get(`/catalog/products`, config);
    callback.success(plainToClass(GetProductsVm, res.data));
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
